import { createAsyncThunk } from "@reduxjs/toolkit";
import PurchaseOrderService from "@/services/api/cresivoxServer/PoService";
import { iPurchaseOrderDTO} from "./Types";
import { apiServer } from "@/services/api/cresivoxServer/axiosConfig";

export const createPurchaseOrder = createAsyncThunk(
  "purchaseOrder/create",
  async (data: iPurchaseOrderDTO, { rejectWithValue }) => {
    try {
      const service = PurchaseOrderService(apiServer);
      const response = await service.createPurchaseOrder(data);
//@ts-expect-error
      if (response?.statusCode === 200) {
        return response?.data;
      } else {
        //@ts-ignore
        return rejectWithValue(response?.errorMessage || "Something went wrong");
      }
    } catch (error: any) {
      return rejectWithValue(error.message || "Network Error");
    }
  }
);


